import React, { useState, Suspense, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import {
    DragDropContext,
    Droppable,
    Draggable
} from 'react-beautiful-dnd';
import {
    createStyles,
    ActionIcon,
    Button,
    Collapse,
    Select,
    TextInput,
    NumberInput,
    Switch,
    Radio,
    SegmentedControl,
    Card,
    Paper,
    Avatar,
    Group,
    rem,
    TypographyStylesProvider,
    Text,
    UnstyledButton,
    UnstyledButtonProps,
    Title,
    Stack,
} from '@mantine/core';
import {
    useDisclosure,
    useListState
} from '@mantine/hooks';
import {
    DatePicker,
    DateRangePicker,
    TimeInput
} from '@mantine/dates';
import {
  IconBell,
  IconGripVertical,
  IconSettings,
  IconUsers,
  IconFileSettings,
  IconUserPlus,
  IconGavel,
  IconBuildingBank,
  IconRepeat,
  IconReceiptRefund,
  IconReceipt,
  IconReceiptTax,
  IconReport,
  IconCashBanknote,
  IconBook,
  IconCalendar,
  IconMessage,
  IconTextRecognition,
  IconPlus,
  IconChevronDown,
  IconChevronUp,
  IconPlaylistAdd,
  IconPencil,
  IconX,
  IconDeviceFloppy,
  IconCheck,
  IconTrash
} from '@tabler/icons';


import { 
    carCreatorTextInfoUpdated,
    carCreatorSelectSectionDataB,
    fetchTests,
    testPost,
    testUpload,
    selectImage
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';
import {
    fieldInfoUpdated,
    selectSectionData,
    obj_fmts,
    arrayAddition
} from '../features/home/homeSlice';
//descript:here for upload tests
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    },
    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
    listItemInput: {
        maxWidth: '200px'
    },
    listItemBtn: {
        border: 'grey solid 1px',
        padding: '8px'
    },
    //added from drag and drop example
    item: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: theme.radius.md,
        border: `${rem(1)} solid ${
          theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
        padding: `${theme.spacing.sm} ${theme.spacing.xl}`,
        paddingLeft: `calc(${theme.spacing.xl} - ${theme.spacing.md})`, // to offset drag handle
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.white,
        marginBottom: theme.spacing.sm,
    },    
    itemDragging: {
        boxShadow: theme.shadows.sm,
    },
    symbol: {
        fontSize: rem(30),
        fontWeight: 700,
        width: rem(60),
    },
    dragHandle: {
        ...theme.fn.focusStyles(),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        color: theme.colorScheme === 'dark' ? theme.colors.dark[1] : theme.colors.gray[6],
        paddingLeft: theme.spacing.md,
        paddingRight: theme.spacing.md,
    },
    
    
}));

//needed: pass params to fill out the areas of the alert item
//export function AlertItem {
const CarCardDetsHighlightsMgmtCE = ({highlight_id}) => {
    const { classes, cx } = useStyles();
    const dispatch = useDispatch();
    const [opened, { toggle }] = useDisclosure(false);
    const [editList, { toggleList }] = useDisclosure(false);
    let highlight_idx = 0;
    let cnt = 0;
    
    const item_name = 'highlights_2_6';
    const component_md = {
        par: 'auctions',
        child: 'carCreatorData',
        section: 'highlightsSection_6'
        //may add sub_state or mode to component meta data
    };
    
    const rdux_map = {
        highlights_2_6: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'highlights_2_6'
            }
        )),
    };
    let highlight_lists = rdux_map['highlights_2_6'];

    for (highlight_idx; highlight_idx < highlight_lists.length; highlight_idx++){
        if (highlight_lists[highlight_idx].id_0 == highlight_id){
            highlight_idx = cnt;
            break;
        }
    }
    
    
    
    //descript:move bullet point items up, down, & to trash
    const moveItem = (direction, index) => {
        console.log(`Move the item @ index ${index} ${direction}`);
    };
    
    //descript:create bullet point item in the highlight list
    //needed:find by id in homeSlice
    const createItem = (val) => {
        //reference  createNewList for how to get the name of template
        console.log(`adding ${val} from input`);
        
        //descript:create model
        let n_highlight_list_item = {...obj_fmts[component_md['par']][component_md['child']][component_md['section']].highlight_item_fmt_6};
        let curr_l = rdux_map['highlights_2_6'][cnt]['items_2_6'].length;
        n_highlight_list_item['id_0'] = nanoid.generate();
        n_highlight_list_item['val_0'] = val;
        n_highlight_list_item['idx_1'] = curr_l;
        n_highlight_list_item['curr_idx_1'] = curr_l;
        let item_descript = `highlights_2_6->id_0:${highlight_id}:items_2_6`;
        dispatch(arrayAddition(
            {
                itemVal: n_highlight_list_item,
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: item_descript
            }
        ));
        setBulletPointVal('');
        //these are specific to arrayAddition
        //access the current highlight list's highlight items
        //value of 'item' in dispatch call
        //`highlights_2_6:${highlight_id}:items_2_6`
        
        
        
        
    }
    

    //descript:save 'items_2_6' and 'title_0' for the highlights list
    const saveListUpdate =() => {
        
        console.log('Save the current state of this list');
    }
    
    
    
    const [list_state, handlers] = useListState(highlight_lists[highlight_idx]);
    const draggable_highllight_items  = rdux_map['highlights_2_6'][cnt]['items_2_6'].map((item, index) => {
        return(
            <>
                <Card
                    key={nanoid()}
                    withBorder={true}
                    maw={800}
                    mx="auto"
                    radius="md"
                >
                    <Group position="apart">
                        <ActionIcon variant="outline" mx="auto" onClick={() => {moveItem('down', index)}}>
                            <IconChevronDown size={18} color="black"/>
                        </ActionIcon>
                        <ActionIcon variant="outline" mx="auto" onClick={() => {moveItem('del', index)}}>
                            <IconTrash size={18} color="red"/>
                        </ActionIcon>
                        <ActionIcon variant="outline" mx="auto" onClick={() => {moveItem('up', index)}}>
                            <IconChevronUp size={18} color="black"/>
                        </ActionIcon>
                    </Group>
                    <br/>
                    <Stack>
                        <Text ta="center">
                            {item.val_0}
                        </Text>
                    </Stack>
                </Card>
                <br/>
            </>
        );
        }
    );
    
    
    //we'll have the same as with the parent context
    const listItemsCtx = (rdux_map['highlights_2_6'][cnt]['items_2_6'].length == 0) ? <Text ta="center">Create New Items For LIst</Text> :  draggable_highllight_items;
    
    const [listingTitle, setListingTitle] = useState(list_state.title_0);
    const [bulletPointVal, setBulletPointVal] = useState('');

    const inputFieldChange = (e, id, evtName) => {
        switch(id){
            case 'title_0':
                setListingTitle(e.target.value);
                if (evtName == 'onKeyPress'){
                    if (e.key.toLowerCase() == 'enter'){
                        saveListUpdate();
                    }
                }
                break;
            case 'title_btn_0':
                saveListUpdate();
                break;
            case 'val_0':
                setBulletPointVal(e.target.value);
                if (evtName == 'onKeyPress'){
                    if (e.key.toLowerCase() == 'enter'){
                        createItem(bulletPointVal);
                    }
                }
                break;
            case 'val_btn_0':
                createItem(bulletPointVal);
                break;
            default:
                console.log('nothing matched')
        }
    };
    //of_note:value attribute will be dependent upon mode create or edit
    //needed: scroll area below this
    return (
        <>
            <Card withBorder radius="sm"  maw={800} mx="auto">
                <Group position="apart">
                
                    {/*needed:onChangeEventLIstener*/}
                    <TextInput
                        className={classes.listItemInput}
                        placeholder="List Title"
                        value={listingTitle}
                        onChange={(e) => inputFieldChange(e, "title_0", "onChange")}
                        onKeyPress={(e) => inputFieldChange(e, "title_0", "onKeyPress")}
                        
                        icon={<IconTextRecognition size={14}/>}
                    />
                    
                    <ActionIcon
                        variant="outline"
                        onClick={(e) => inputFieldChange(e, "title_btn_0", "onClick")}
                    >
                        <IconCheck size={18} color="black"/>
                    </ActionIcon>
                </Group>
                <br/>
                <Group position="apart">
                    <TextInput
                        className={classes.listItemInput}
                        placeholder="Bullet Point"
                        value={bulletPointVal}
                        onChange={(e) => inputFieldChange(e, "val_0", "onChange")}
                        onKeyPress={(e) => inputFieldChange(e, "val_0", "onKeyPress")}
                    />
                    <ActionIcon
                        variant="outline"
                        onClick={(e) => inputFieldChange(e, "val_btn_0", "onClick")}
                    >
                        <IconPlus size={18} color="limegreen"/>
                    </ActionIcon>
                </Group>
                <br/>
                <Group position="apart">
                    <ActionIcon variant="outline" onClick={() => {saveListUpdate()}}>
                        <IconDeviceFloppy size={18} color="blue"/>
                    </ActionIcon>
                    <ActionIcon variant="outline"  onClick={toggle}>
                        <IconChevronDown size={18} color="black"/>
                    </ActionIcon>
                </Group>
            </Card>
            
            <br/>
            <br/>
            <Collapse in={opened} maw={800} mx="auto">
                <Title>
                    List Items
                </Title>
                <br/>
                {/*draggable_highllight_items*/}
                {listItemsCtx}
            </Collapse>
        </>
    );
    
}

export default CarCardDetsHighlightsMgmtCE
